module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Outgoing-box-af6541f907b0e33bdb42bfdebc55d1ae.svg";